import { Tooltip } from 'bootstrap';

export default {
  mounted(el, binding) {
    el.dataset.bsTitle = binding.value;
    new Tooltip(el);
  }
}